import produce from 'immer';

const INITIAL_STATE = {
  opened: false,
};

export default function dialog(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@dialog/OPEN': {
        draft.opened = true;
        break;
      }

      // Adicionar case
case '@estoquePostoMonitor/SUCCESS_REMOVE':
      case '@notasFiscaisRecebidas/SUCCESS_REMOVE':
      case '@usuarios/SUCCESS_REMOVE':
      case '@padroes/SUCCESS_REMOVE':
      case '@mensagensTCAGeral/SUCCESS_REMOVE':
      case '@veiculoMensagemTCA/SUCCESS_REMOVE':
      case '@msgtcaPostoLoco/SUCCESS_REMOVE':
      case '@msgtcaPosto/SUCCESS_REMOVE':
      case '@vazaoEquipamentosBicos/SUCCESS_REMOVE':
      case '@modeloEquipamento/SUCCESS_REMOVE':
      case '@justificativaTrocaModoOperacional/SUCCESS_REMOVE':
      case '@alarmeSistema/SUCCESS_REMOVE':
      case '@precoproduto/SUCCESS_REMOVE':
      case '@operacaotransferencia/SUCCESS_REMOVE':
      case '@operacaoLubrificacao/SUCCESS_REMOVE':
      case '@perfis/SUCCESS_REMOVE':
      case '@gerencias/SUCCESS_REMOVE':
      case '@causasManutencoes/SUCCESS_REMOVE':
      case '@safras/SUCCESS_REMOVE':
      case '@arqueacoes/SUCCESS_REMOVE':
      case '@bico/SUCCESS_REMOVE':
      case '@centrocusto/SUCCESS_REMOVE':
      case '@comboio/SUCCESS_REMOVE':
      case '@configuracaoalarmetanque/SUCCESS_REMOVE':
      case '@contrato/SUCCESS_REMOVE':
      case '@empresasveiculo/SUCCESS_REMOVE':
      case '@marcasveiculo/SUCCESS_REMOVE':
      case '@medidor/SUCCESS_REMOVE':
      case '@modelosveiculo/SUCCESS_REMOVE':
      case '@motorista/SUCCESS_REMOVE':
      case '@operacao/SUCCESS_REMOVE':
      case '@operacaoabastecimento/SUCCESS_REMOVE':
      case '@operacaoestoqueposto/SUCCESS_REMOVE':
      case '@operacaoestoquetanque/SUCCESS_REMOVE':
      case '@operacaorecebimento/SUCCESS_REMOVE':
      case '@posto/SUCCESS_REMOVE':
      case '@produto/SUCCESS_REMOVE':
      case '@tanquesfisicos/SUCCESS_REMOVE':
      case '@tanquesvirtual/SUCCESS_REMOVE':
      case '@terminal/SUCCESS_REMOVE':
      case '@usuario/SUCCESS_REMOVE':
      case '@veiculo/SUCCESS_REMOVE':
      case '@estoqueproduto/SUCCESS_REMOVE':
      case '@operacaoLimpezaTag/SUCCESS_REMOVE':
      case '@operacaoTotalizadorVeiculo/SUCCESS_REMOVE':
      case '@auth/SIGN_OUT':
      case '@dialog/CLOSE': {
        draft.opened = false;
        break;
      }

      default:
    }
  });
}
